export default __webpack_public_path__ + "static/media/arrow_back.39c0f44f.svg";